import styled from 'styled-components'

const Wrapper = styled('div')`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  padding: 24px;
`

export default Wrapper
